/* globals jQuery */
import 'fitvids.1.1.0'
import 'flexslider'
import 'magnific-popup'
import objectFitImages from 'object-fit-images'

import responsiveNav from './responsive-nav.jquery.js'
import accordion from './jquery.accordion.js'
import './sticky-header.js'


(($) => {

    $.fn.responsiveNav = responsiveNav
    $.fn.accordion = accordion

    //main hero slideshow
    $('.slideshow.flexslider').flexslider();

    // Make nav menu nice & responsive
    $('nav.main-nav').responsiveNav({
        navType: 'dropdown', //default option for dropdown type use 'dropdown'
        closeOnOutsideClick: true, //set to false if using dropdown type
        showTabsOnFocus: true,
    });

    // Responsive Videos
	$('.rtecontent, .video_row_large, #video-popup').fitVids();
	
	$('.js-toggle-submenu').on('click',function(){
		$(this).next().slideToggle();
	});
	//i know its weird but check the resize function in responsive-nav for making sure the submenu
	//shows when sizing from mobile back to desktop view

    //polyfill for IE object-fit on images - https://github.com/fregante/object-fit-images
    var $objectFit = $('img.object-fit');
    objectFitImages($objectFit);

    // Accordions
    $('dl.accordion').accordion();

    //Staff Details Popup
    $('.staff-popup').magnificPopup({
      type:'inline',
      midClick: true, // Allow opening popup on middle mouse click. Always set it to true if you don't provide alternative source in href.
      removalDelay: 300,
      mainClass: 'mfp-fade',
      closeMarkup: '<button title="%title%" type="button" class="mfp-close"></button>',
      callbacks: {
          elementParse: function(item) {

              var data = {
                  action : 'get_staff',
                  staffId : $(item.el).data('id'),
                  postType : $(item.el).data('postType')
              };

              $.post(wp_ajax.url, data, function(response) {
                  $('#staff-popup').append(response.html);
                  $('#staff-popup .spinner').hide();
              });
          },
          close: function(){
              $('#staff-popup .spinner').show();
              $('#staff-popup .employee-details').remove();
          }
      }
    });

    //Home Page Video Popup
    $('.video-popup').magnificPopup({
      type:'inline',
      midClick: true, // Allow opening popup on middle mouse click. Always set it to true if you don't provide alternative source in href.
      removalDelay: 300,
      mainClass: 'mfp-fade',
      closeMarkup: '<button title="%title%" type="button" class="mfp-close"></button>',
    });

    //Category filtering on projects archive page
    var $CatDropdown = $('select#articleCat');
        $CatDropdown.change(function(){
        window.location.href = $CatDropdown.val();
    });

    //Alert height adjustment
    $(document).ready(function(){
        if ($('.mtsnb-shown').length && $(window).scrollTop() <= $('.mtsnb').outerHeight(false)) {
            $('header.site-header').css('top','+=' + $('.mtsnb').outerHeight(false));
        }
    });

})(jQuery)
